var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "#C20000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.411 3.74397H12.4016V2.00649C12.4016 1.45165 11.9499 1 11.3941 1H6.14332C5.588 1 5.13635 1.45165 5.13635 2.00649V3.74397H2.00649C1.45165 3.74397 1 4.19561 1 4.75094V5.76174C1 6.31707 1.45165 6.76919 2.00649 6.76919H2.40054L2.79843 18.6671C2.79843 19.2483 3.27072 19.7206 3.85196 19.7206H13.566C14.1472 19.7206 14.6195 19.2483 14.619 18.6829L15.0169 6.76919H15.4105C15.9663 6.76919 16.4184 6.31707 16.4184 5.76174V4.75094C16.4189 4.19561 15.9668 3.74397 15.411 3.74397ZM13.6596 18.6676C13.6596 18.7199 13.6183 18.7611 13.566 18.7611H3.85196C3.79964 18.7611 3.75837 18.7199 3.75837 18.6512L3.36143 6.76919H14.057L13.6596 18.6676ZM15.459 5.76222C15.459 5.78766 15.4364 5.80974 15.411 5.80974H14.5533H2.86467H2.00601C1.98057 5.80974 1.95945 5.78814 1.95945 5.76222V4.75142C1.95945 4.7255 1.98009 4.70438 2.00601 4.70438H5.61583C5.88078 4.70438 6.0958 4.48935 6.0958 4.22441V2.00697C6.0958 1.98105 6.11692 1.96041 6.14284 1.96041H11.3941C11.4205 1.96041 11.4417 1.98105 11.4417 2.00697V4.22441C11.4417 4.48935 11.6562 4.70438 11.9216 4.70438H15.411C15.4369 4.70438 15.459 4.72598 15.459 4.75142V5.76222Z",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77178 3.28223H7.64745C7.38251 3.28223 7.16748 3.49725 7.16748 3.76219C7.16748 4.02713 7.38251 4.24216 7.64745 4.24216H9.77178C10.0372 4.24216 10.2517 4.02713 10.2517 3.76219C10.2517 3.49725 10.0372 3.28223 9.77178 3.28223Z",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e6beffd35b5371768f7d2f5788730066.svg";
export { ForwardRef as ReactComponent };